import { useContext } from "react";
import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { cardStyle } from "../cardStyles";

interface ValidationBarProps {
  totalPercentage: number;
  onSave: () => void;
}

const ValidationBar = ({ totalPercentage, onSave }: ValidationBarProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  const isValid = totalPercentage === 100;
  const isOver = totalPercentage > 100;

  const barColor = isValid ? "#059669" : isOver ? "#dc2626" : "#d97706";
  const barBg = isValid ? "#ecfdf5" : isOver ? "#fef2f2" : "#fffbeb";
  const barTextColor = isValid ? "#065f46" : isOver ? "#991b1b" : "#92400e";

  return (
    <div
      style={{
        ...cardStyle,
        backgroundColor: barBg,
        border: `1px solid ${barColor}20`,
        padding: 20,
      }}
    >
      <div
        style={{
          height: 8,
          backgroundColor: `${barColor}20`,
          borderRadius: 4,
          overflow: "hidden",
          marginBottom: 12,
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${Math.min(totalPercentage, 100)}%`,
            backgroundColor: barColor,
            borderRadius: 4,
            transition: "width 0.3s ease",
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <GlobalIcon
            iconName={isValid ? "CircleCheckFilledIcon" : "AlertCircleIcon"}
            size="XS"
            color={barColor}
          />
          <span style={{ fontSize: 14, fontWeight: 600, color: barTextColor }}>
            {isValid
              ? translate("newDashboard.beneficiaryManager.validation.perfect")
              : `${translate(
                  "newDashboard.beneficiaryManager.validation.error"
                )} (${translate(
                  "newDashboard.beneficiaryManager.validation.current"
                ).replace("{percent}", String(totalPercentage))})`}
          </span>
        </div>
        <ButtonDS
          label={translate("newDashboard.beneficiaryManager.save")}
          buttonType="primary"
          size="40"
          disabled={!isValid}
          onClick={onSave}
        />
      </div>
    </div>
  );
};

export default ValidationBar;
